/* eslint-disable */
import React from 'react';
import { parseMoney } from '../../utils';

const MoneyAnnualTable = (props) => {
  let compareWith, finalCompareTitle = ''
  let numberCompare;
  if (props.page === 'docs_pnl' || props.page === 'docs_pnl-moneypdf') {
    numberCompare = props.aggregateData?.annual_docs_n?.[props.year] ?? 0;
  } else {
    if (props.page === 'practice') {
      numberCompare = props.n
    } else {
      numberCompare = props.aggregateData?.annual_n?.[props.year] ?? 0;
    }
  }

  if (props.page !== 'practice') {
    compareWith = props.filters.compare_with;
    finalCompareTitle = props.page === 'docs_pnl' && compareWith !== 'NSCHBC' ? 'Peers' : compareWith
  }

  const buildRows = () => {
    return props.rows.map((row, i) => {
      let underlineFormat, toplineFormat;
      if (row.forecast) {
        if (row.forecast.total) {
          if (row.forecast.total.boldedUnderline) {
            underlineFormat = 'solid 1px';
          } else if (row.forecast.total.doubleUnderline) {
            underlineFormat = 'double 1px';
          } else if (row.forecast.total.underline) {
            underlineFormat = 'solid 1px';
          }

          if (row.forecast.total.topline) {
            toplineFormat = 'solid 1px'
          } else {
            toplineFormat = ''
          }

        } else if (row.forecast) {
          if (row.forecast.boldedUnderline) {
            underlineFormat = 'solid 1px';
          } else if (row.forecast.doubleUnderline) {
            underlineFormat = 'double 1px';
          } else if (row.forecast.underline) {
            underlineFormat = 'solid 1px';
          }

          if (row.forecast.topline) {
            toplineFormat = 'solid 1px'
          } else {
            toplineFormat = ''
          }
        }
      }

      if (row.topline) {
        toplineFormat = 'solid 1px'
      }

      const copyRowStyle = {
        ...row.style,
        borderBottom: underlineFormat,
        borderTop: toplineFormat
      }

      const copyCellStyle = row.whiteSpace ? 'table-copy wrap-copy-cell' : 'table-copy';

      let hideRow = '';
      let zeroYears = [];
      props.yearRange.forEach(y => { row[y] === 0 && Math.abs(row['you' + y]).toFixed(1) === '0.0' && Math.abs(row['avg' + y]).toFixed(1) === '0.0' ? zeroYears.push(y) : null })
      zeroYears.length === props.yearRange.length ? hideRow = row.copy : null

      let rowChecked = row.displayChart && row.checked && props.editMetrics ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''

      if (row.emptyRow) {
        return (
          <tr key={Math.random(i)} id={`${props.chart}-report-row-${i}`}>
            {props.page === 'money' ? <td className='row-check'></td> : null}
            <td className='table-copy'></td>
            {props.yearRange.map((year, ii) => {
              let arrowCellClass = props.pdf ? 'common-size-arrow-pdf' : 'common-size-arrow';
              let backgroundStyle = { height: '20px' }
              let commonSizeValCellClass = props.pdf ? 'common-size-cell-pdf' : 'common-size-cell';
              let valueCellClass = '';
              let noEndSpaceCell = props.yearRange.length - 1 == ii;

              if (ii % 2 === 0 && (!props.pdf || (props.pdf && props.yearRange.length !== 2))) {
                arrowCellClass += ' money-table-cell';
                backgroundStyle['backgroundColor'] = '#BFE0AE';
                commonSizeValCellClass += ' money-table-cell';
                valueCellClass = 'money-table-cell';
              }

              return (
                <React.Fragment key={Math.random(ii)}>
                  <td key={ii} className={valueCellClass} style={backgroundStyle}></td>
                  <td className={commonSizeValCellClass} style={backgroundStyle}></td>
                  {props.page !== 'practice' && compareWith === 'None' ? null : <td className={arrowCellClass} style={backgroundStyle}></td>}
                  {props.page !== 'practice' && compareWith === 'None' ? null : <td className={commonSizeValCellClass} style={backgroundStyle}></td>}
                  {noEndSpaceCell ? null : <td className='space-cell'></td>}
                </React.Fragment>
              )
            })}
          </tr>
        )
      } else {
        return (
          <tr style={hideRow === row.copy && !row.alwaysDisplayRow ? { display: 'none' } : copyRowStyle} key={Math.random(i)} id={`${props.chart}-report-row-${i}`} onClick={() => row.displayChart && props.editMetrics ? props.handleSelectAndLayout('money', props.sheet, row.relatedCheckedKey) : null}>
            {props.page === 'practice' || props.page === 'docs_pnl' || props.pdf ? null : <td>{rowChecked}</td>}
            {row.copy === 'Current Liabilities'
              ? <td className={copyCellStyle} style={{ paddingTop: '20px' }}>{row.copyWithPadding}</td>
              : <td className={copyCellStyle}>{row.copyWithPadding}</td>}
            {props.yearRange.map((year, ii) => {
              let arrowCellClass = props.pdf ? 'common-size-arrow-pdf' : 'common-size-arrow';
              let backgroundStyle = {}
              let commonSizeValCellClass = props.pdf ? 'common-size-cell-pdf' : 'common-size-cell';
              let valueCellClass = '';
              let noEndSpaceCell = props.yearRange.length - 1 == ii

              if (ii % 2 === 0 && (!props.pdf || (props.pdf && props.yearRange.length !== 2))) {
                arrowCellClass += ' money-table-cell';
                backgroundStyle['backgroundColor'] = '#BFE0AE';
                commonSizeValCellClass += ' money-table-cell';
                valueCellClass = 'money-table-cell';
              }
              try {
                if (props.commonSizeTable) {
                  return (
                    <td key={Math.random(ii)} style={{ textAlign: 'center' }} >
                      {row[year].toFixed(2)}%
                    </td>
                  )
                } else {
                  // return blank td's if on a header
                  if (Object.keys(row).length > 2) {
                    let arrowColumn = '';
                    let yearValue = parseMoney(row[year]);
                    let youPercentage = _.isNumber(row['you' + year]) ? row['you' + year].toFixed(1) + '%' : '-';
                    let avgPercentage = _.isNumber(row['avg' + year]) ? row['avg' + year].toFixed(1) + '%' : '-';
                    if (row['status' + year] === 'worse' || row['status' + year] === 'worst') {
                      arrowColumn = <p className='common-size-arrow-red' style={{ margin: 0, color: 'red' }}>&#9660;</p>
                    } else if (row['status' + year] === 'better' || row['status' + year] === 'best') {
                      arrowColumn = <p className='common-size-arrow-green' style={{ margin: 0, color: 'green' }}>&#9650;</p>
                    }

                    if (youPercentage === '-' && avgPercentage === '-') {
                      youPercentage = ''
                      avgPercentage = ''
                    }

                    return (
                      <React.Fragment key={Math.random(ii)}>
                        <td key={ii} className={valueCellClass} style={backgroundStyle}>
                          {yearValue}
                        </td>
                        <td className={commonSizeValCellClass} style={backgroundStyle}>
                          {youPercentage}
                        </td>
                        {props.page !== 'practice' && compareWith === 'None'
                          ? null
                          : <td className={arrowCellClass} style={backgroundStyle}>
                            {arrowColumn}
                          </td>}
                        {props.page !== 'practice' && compareWith === 'None'
                          ? null
                          : <td className={commonSizeValCellClass} style={backgroundStyle}>
                            {avgPercentage}
                          </td>}
                        {noEndSpaceCell ? null : <td className='space-cell'></td>}
                      </React.Fragment>
                    )
                  } else {
                    return (
                      <React.Fragment key={Math.random(ii)}>
                        <td className={valueCellClass} style={backgroundStyle}></td>
                        <td className={commonSizeValCellClass} style={backgroundStyle}></td>
                        {props.page !== 'practice' && compareWith === 'None' ? null : <td className={arrowCellClass} style={backgroundStyle}></td>}
                        {props.page !== 'practice' && compareWith === 'None' ? null : <td className={commonSizeValCellClass} style={backgroundStyle}></td>}
                        {noEndSpaceCell ? null : <td className='space-cell'></td>}
                      </React.Fragment>
                    )
                  }
                }
              } catch (error) {
                console.log(error, 'err')
                return (<td key={Math.random(ii)}></td>);
              }
            })}
          </tr>
        )
      }
    })
  }

  const renderYearHeaderColumns = (years) => {
    const currentYear = new Date().getFullYear();
    let youPeersRow = [];
    let formatedYearsRow = [];
    let twoClasses = props.pdf ? 'common-size-arrow-pdf' : 'common-size-arrow money-table-cell'

    years.forEach((y, i) => {
      const year = Number(y);
      let arrowCellClass = props.pdf ? 'common-size-arrow-pdf' : 'common-size-arrow';
      let backgroundStyle = {}
      let commonSizeValCellClass = props.pdf ? 'common-size-cell-pdf' : 'common-size-cell';
      let valueCellClass = '';
      let youDate, compareDate = '';
      let noEndSpaceCell = years.length - 1 == i

      if (year === currentYear) {
        youDate = props.companyYTDDate;
        compareDate = props.aggregateYTDDate;
      } else {
        youDate = props.calendarYearEnd ? `${props.fiscalYearEnd}/${year}` : props.fiscalYearEnd ? `${props.fiscalYearEnd}/${year + 1}` : `12/31/${year}`;
        compareDate = `12/31/${year}`;
      }

      if (i % 2 === 0 && (!props.pdf || (props.pdf && props.yearRange.length !== 2))) {
        let tableCellClass = 'money-table-cell'
        arrowCellClass += ' ' + tableCellClass;
        backgroundStyle['backgroundColor'] = '#BFE0AE';
        commonSizeValCellClass += ' ' + tableCellClass;
        valueCellClass = tableCellClass
      }

      if (props.page !== 'practice' && compareWith === 'None') {
        youPeersRow.push(
          <React.Fragment key={Math.random(i)}>
            <td colSpan='2' className={commonSizeValCellClass} style={backgroundStyle}>You</td>
            {noEndSpaceCell ? null : <td className='space-cell'></td>}
          </React.Fragment>
        )

        formatedYearsRow.push(
          <React.Fragment key={Math.random(i)}>
            <td colSpan='2' className={commonSizeValCellClass} style={backgroundStyle}>{youDate}</td>
            {noEndSpaceCell ? null : <td className='space-cell'></td>}
          </React.Fragment>
        )
      } else {
        youPeersRow.push(
          <React.Fragment key={Math.random(i)}>
            <td colSpan='2' className={commonSizeValCellClass} style={backgroundStyle}>{props.page === 'practice' ? 'Your Avg Client' : 'You'}</td>
            <td className={arrowCellClass} style={backgroundStyle}></td>
            <td className={commonSizeValCellClass} style={backgroundStyle}>{props.page === 'practice' ? 'Peerview Avg Client' : <div className='compare-with-title'>{finalCompareTitle}</div>}</td>
            {noEndSpaceCell ? null : <td className='space-cell'></td>}
          </React.Fragment>
        )

        formatedYearsRow.push(
          <React.Fragment key={Math.random(i)}>
            <td colSpan='2' className={commonSizeValCellClass} style={backgroundStyle}>{youDate}</td>
            <td className={arrowCellClass} style={backgroundStyle}></td>
            <td className={commonSizeValCellClass} style={backgroundStyle}>{compareDate}</td>
            {noEndSpaceCell ? null : <td className='space-cell'></td>}
          </React.Fragment>
        )
      }

    })

    return (
      <thead>
        <tr key={Math.random(20)}>
          {props.page === 'practice' || props.page === 'docs_pnl' || props.pdf
            ? <td></td>
            : (<td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td>)}
          {props.page === 'practice' || props.page === 'docs_pnl' || props.pdf ? null : <td></td>}
          {youPeersRow}
        </tr>
        <tr key={Math.random(20)}>
          <td></td>
          {props.page === 'practice' || props.page === 'docs_pnl' || props.pdf ? null : <td></td>}
          {formatedYearsRow}
        </tr>
      </thead>
    )
  }

  const addDeltaColumn = (row) => {
    let classNames = props.pdf ? 'common-size-cell-pdf' : 'common-size-cell money-table-cell'
    let cellStyle = props.pdf ? {} : { 'backgroundColor': '#BFE0AE' }

    if (_.isNumber(row[props.yearRange[0]]) || _.isNumber(row[props.yearRange[1]])) {
      return <td className={classNames} style={cellStyle}>{parseMoney(row[props.yearRange[1]] - row[props.yearRange[0]])}</td>
    } else {
      return <td className={classNames} style={cellStyle}></td>
    }
  }

  const buildTable = () => {
    if (props.pdf) {
      if (props.page !== 'practice') {
        // let sheetTitle = props.continued ? `${props.title} - ${props.clientName} (Continued)` : `${props.title} - ${props.clientName}`
        let clientNames = props.realName ? `${props.realName} / ${props.clientName}` : props.clientName
        let yearRangeText = `${props.yearRange[0]} - ${props.yearRange[props.yearRange.length - 1]}`
        let printViewClass = props.yearRange.length === 2 ? 'money-pdf-portrait' : 'report-pdf-landscape'
        const tabName = (props.tabName || props.title || '').trim().toLowerCase();
        const title = (props.title || '').trim().toLowerCase();
        let reportTitle = tabName.includes(title) ? props.tabName || props.title : `${props.tabName}, ${props.title} Benchmark Report`;
        let naicsCode = props.filters.code;
        let dataType = props.filters.datatype;
        let revenueBand = props.filters.revenue_band;
        let region = props.filters.region;
        let numOfDocs = props.filters.number_of_pros || 'All'
        let compare = props.filters.compare_with
        let filtersTitle = props.page === 'docs_pnl' || props.page === 'docs_pnl-moneypdf' ? `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, # of Doctors: ${numOfDocs}, Compare with: ${compare}` : `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Compare with: ${compare}`;
  
        return (
          <div className={printViewClass}>
            <div>
              {props.yearRange.length === 2
                ? (
                  <div>
                    <p className='report-annual-title'>{reportTitle}</p>
                    <p className='report-company-title'>{clientNames}</p>
                    <p className='report-year-range-title'>{yearRangeText}</p>
                    <p className='report-filters-title'>{filtersTitle}</p>
                  </div>
                )
                : <div>
                  <p className='report-annual-title'>{`${reportTitle}, ${clientNames}, ${yearRangeText}`}</p>
                  <p className='report-filters-title'>{filtersTitle}</p>
                </div>
              }
              <div className='money-pdf-table-div'>
                <table style={{ whiteSpace: 'pre' }} className='money-pdf-table' >
                  {renderYearHeaderColumns(props.yearRange)}
                  <tbody>
                    {buildRows()}
                    <tr><td className='footer-cell'><i>n = {numberCompare}</i></td></tr>
                  </tbody>
                </table>
                {props.page === 'docs_pnl' || props.page === 'docs_pnl-moneypdf' ? <p className='doctor-asterisk-note'>*The sub-accounts might not add up to total account if details are not provided.</p> : null}
              </div>
            </div>
            <p className='pdf-disclaimer-text'>{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
          </div>
        )
      } else {
        return (
          <div className={'report-pdf-landscape'}>
            <div>
              <div className='money-pdf-table-div'>
                <table style={{ whiteSpace: 'pre' }} className='money-pdf-table' >
                  {renderYearHeaderColumns(props.yearRange)}
                  <tbody>
                    {buildRows()}
                    <tr><td className='footer-cell'><i>n = {numberCompare}</i></td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p className='pdf-disclaimer-text'>{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
          </div>
        )
      }
    } else {
      let tableID = props.page !== 'docs_pnl' ? `new-annual-table-${props.sheet}` : `new-annual-table-docs_pnl`
      return (
        <div className='money-report-card'>
          <div className='money-report-pdf'>
            <div className='money-report-container'>
              <table id={tableID} style={{ whiteSpace: 'pre' }} className='report-table' >
                {renderYearHeaderColumns(props.yearRange)}
                <tbody>
                  {buildRows()}
                </tbody>
                <tfoot>
                  {props.page === 'practice'
                    ? <tr><td><i>Displaying {numberCompare} of your clients</i></td></tr>
                    : <>
                      <tr><td><i>n = {numberCompare}</i></td></tr>
                      {['Peers', 'NSCHBC'].includes(compareWith) || compareWith.includes('Peers') ? <tr><td colSpan='2' className='peer-disclaimer'>Peer data is updated monthly on or after the 16th.</td></tr> : null}
                    </>
                    }
                </tfoot>
              </table>
              {props.page === 'docs_pnl' || props.page === 'docs_pnl-moneypdf' ? <p className='doctor-asterisk-note'>*The sub-accounts might not add up to total account if details are not provided.</p> : null}
            </div>
          </div>
        </div>
      )
    }
  }

  return (buildTable())
}

export default MoneyAnnualTable;
